export const AdminRouter = {
  component: () => import("@/layouts/MainLayout.vue"),
  props: () => {
    return {
      menuItems: [

        {
          label: "Usuarios",
          icon: "fa-solid fa-file-contract",
          name: "usuariosoficialia",
          to: "/usuarios",
          component: "@/modules/usuario/views/oficialiaUsuario",
        },

        {
          label: "Administrador",
          icon: "fa-solid fa-file-contract",
          name: "usuariosAdmin",
          to: "/administrador",
          component: "@/modules/admin/views/adminUsuarios",
        },
        {
          label: "Leyendas",
          icon: "fa-solid fa-file-contract",
          name: "leyendas",
          to: "/leyendas",
          component: "@/modules/admin/views/LeyendasView",
        },

        {
          label: "Directorio",
          icon: "fa-solid fa-file-contract",
          name: "directorio",
          to: "/directorio",
          component: "@/modules/admin/views/DirectorioView",
        },

        {
          label: "Estadisticas",
          icon: "fa-solid fa-file-contract",
          name: "estadisticas",
          to: "/estadisticas",
          component: "@/modules/admin/views/EstadisticasView",
        },
        {
          label: "Bitacora",
          icon: "fa-solid fa-file-contract",
          name: "bitacora",
          to: "/bitacora",
          component: "@/modules/admin/views/BitacoraView",
        },

      ],
    };
  },
  children: [
    {
      path: "",
      component: () => import("@/modules/admin/views/adminUsuarios.vue"),
    },
    {
      name: 'leyendas',
      path: "/leyendas",
      component: () => import("@/modules/admin/views/LeyendasView.vue"),
    },
    {
      name: 'directorio',
      path: "/directorio",
      component: () => import("@/modules/admin/views/DirectorioView.vue"),
    },
    {
      name: 'estadisticas',
      path: "/estadisticas",
      component: () => import("@/modules/admin/views/EstadisticasView.vue"),
    },
    {
      name: 'bitacora',
      path: "/bitacora",
      component: () => import("@/modules/admin/views/BitacoraView.vue"),
    },

  ],
};

export const OficialiaAdjuntosRouter = {
  component: () => import("@/layouts/MainLayout.vue"),
  props: () => {
    return {
      menuItems: [

        {
          label: "Adjuntos",
          icon: "fa-solid fa-file-contract",
          name: "obtenerOficios",
          to: "/obtenerOficios",
          component: "@/modules/usuario/views/obtenerOficios",
        },
        {
          label: "sexo",
          icon: "fa-solid fa-file-contract",
          name: "OficialiaAdjuntos",
          to: "/OficialiaAdjuntos",
          component: "@/modules/usuario/views/oficialiaAdjuntos",
        },



      ],
    };
  },
  children: [
    {
      path: "",
      component: () => import("@/modules/usuario/views/oficialiaAdjuntos.vue"),
    },
    {
      path: "/obtenerOficios",
      component: () => import("@/modules/usuario/views/obtenerOficios.vue"),
    },


  ],
};